import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IPageableResponse} from '../../../../global/pagging.dto';
import {IRecipientDto} from '../../documents/dto/document-listing.dto';
import {IOrganizationDTO, LinkedContracts, LinkedDocuments} from './organizations.dto';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class OrganizationService {
    constructor (private http:HttpClient) {
        
    }

    /**
     * Fetch organization with paginationa and queryString
     * @param page
     * @param query
     * @returns response
     */
    fetchOrganization(page: number, query:string, p: string = ''){
        return this.http.get<IPageableResponse<IOrganizationDTO> | IOrganizationDTO[]>(`organizations?page=${page}&q=${query}&p=${p}`);
    }


    
    /**
     * Create organization
     * @param formData 
     * @returns response
     */
    addOrganization(formData: FormData | IAddOrganization) {
        return this.http.post<IOrganizationDTO>('organizations', formData);
    }



    /**
     * Update organization
     * @param formData
     * @param id
     * @returns response
     */
    updateOrganization(formData:FormData, id: number){
        return this.http.post<IOrganizationDTO>(`organizations/${id}`, formData);
    }


    /**
     * Get linked documents with recipient
     * @param id 
     * @returns 
     */
    getLinkedDocuments(id):Observable<LinkedDocuments[]> {
        return this.http.get<LinkedDocuments[]>(`organizations/link/document/${id}`);
    }

    /**
     * Get linked contracts with recipient
     * @param id 
     * @returns 
     */
    getLinkedContracts(id):Observable<LinkedContracts[]> {
        return this.http.get<LinkedContracts[]>(`organizations/link/contractcontrol/${id}`);
    }

    /**
     * Delete organization
     * @param id 
     * @returns response
     */
    deleteOrganization(id:number) {
        return this.http.delete(`organizations/${id}`);
    }



    /**
     * Search recipient
     * @param query 
     * @returns response
     */
    searchRecipient(query:string) {
        return this.http.get<ISearchRecipientResponse[]>('recipients/searchorganization?q='+ query);
    }



    /**
     * Link recipient with organization
     * @param formData 
     * @returns response
     */
    link(formData: { id:number }){
        return this.http.put(`recipients/${formData?.id}/link`, formData);
    }



    /**
     * Retrieves the image of an organization as a streamable file.
     *
     * @param organizationId - The unique identifier of the organization.
     * @returns An observable of the HTTP GET request to fetch the organization's image.
     */
    getOrganizationImagesPath(organizationId: number): string {
        return `${environment.apiUrl}organizations/${organizationId}/stream-file`;
    }
}


export interface IAddOrganization{
    address?:            string;
    city?:               string;
    name:                string;
    organization_image?: string;
    phone?:              string;
    register_no:         string;
    zipcode?:            string;
}

export interface ISearchRecipientResponse extends  IRecipientDto{
    name:      null | string;
}
